import { formatAttributionPageLabel, httpsHrefFromUrl } from '@/lib/campaign-page-url'
import styles from './ConversionPageLink.module.css'

type ConversionPageLinkProps = {
  display: string | null | undefined
  rawUrl?: string | null
  emptyLabel?: string
  showRawWhenDifferent?: boolean
}

export function ConversionPageLink({
  display,
  rawUrl = null,
  emptyLabel = 'Origem não identificada',
  showRawWhenDifferent = false,
}: ConversionPageLinkProps) {
  const label = formatAttributionPageLabel(display) || emptyLabel
  const href = httpsHrefFromUrl(display) ?? httpsHrefFromUrl(rawUrl)
  const sanitized = formatAttributionPageLabel(rawUrl)
  const showSanitized =
    showRawWhenDifferent && sanitized !== '' && sanitized !== label

  return (
    <div className={styles.wrap}>
      {href ? (
        <a
          className={styles.link}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      ) : (
        <span className={styles.text}>{label}</span>
      )}
      {showSanitized ? (
        <p className={styles.raw}>URL sanitizada: {sanitized}</p>
      ) : null}
    </div>
  )
}
